//
//
//
//
//
//

import Sizeable from "../../../mixins/Sizeable";

export default {
    name: "NavListHeader",

    mixins: [Sizeable],

    props: {

    }
}
